// Every Scan entry point on the web (the phone floating Scan button and the
// desktop header Scan button, both inside navigation v2) stays hidden until
// the iOS release with the scanner is live. Same two switches as navV2:
//  - VITE_SCAN_CTA (build time, default OFF; "1" or "true" turns it on);
//  - a per-browser override in localStorage (`cb.scanCta` = "1" / "0"),
//    written by `?scan_cta=1|0` on any page and removed by `?scan_cta=clear`.
// Off means there is no Scan anywhere on web. It only ever adds to nav v2:
// with nav v2 off there is no Scan either way.

import { SCAN_CTA_QUERY_PARAM, SCAN_CTA_STORAGE_KEY } from './navV2.codes'
import { createPreviewFlag, envOn } from './previewFlag'
import { isAndroidApp } from './androidApp'

export { SCAN_CTA_QUERY_PARAM, SCAN_CTA_STORAGE_KEY }

const flag = createPreviewFlag(SCAN_CTA_STORAGE_KEY, SCAN_CTA_QUERY_PARAM, envOn(import.meta.env.VITE_SCAN_CTA))

/**
 * True when this page load may show a Scan entry point. Stable for the
 * session. Always on inside our Android app, where Scan opens the app's own
 * scanner (ScanFab, ScanButton) and the home copy points at it.
 */
export function scanCtaEnabled(): boolean {
  return flag.enabled() || isAndroidApp()
}

/** Test seam. */
export function __resetScanCtaForTests(): void {
  flag.reset()
}
